/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { CardContent } from '../../../Shared/Card'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import React from 'react'
import { CardTitle } from '../../../Shared/CardTitle'
import { THEME_COLORS } from '../../../../Shared/theme'

const NoNegativeActivityCardContent = () => {
    const [t] = useTranslation()

    return (
      <CardContent
        css={css`
            display: grid;
            place-items: center;
            gap: .5rem;
            grid-template-areas: 'title' 'a';
            grid-template-rows: 30px 1fr;
        `}
      >
          <CardTitle
            title={format(new Date(), 'MMMM', {locale: fr})}
          />

          <div
            css={css`
                grid-area: a;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.5rem;
            `}
          >
              <Icon name="checkmark" size="huge" color="green"/>
              <p
                css={css`
                    font-weight: bold;
                    color: ${THEME_COLORS.GREEN};
                `}
              >{t('dashboard.negative_activity.all_orders_acquired')}
              </p>
          </div>
      </CardContent>
    )
}

export { NoNegativeActivityCardContent }
